module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper listaPropostas",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": "SGP - Listagem de Propostas"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Propostas")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Proposta',
        href: '#'
      }, {
        text: 'Lista',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row collapse in",
    staticStyle: {
      "width": "inherit",
      "height": "auto"
    },
    attrs: {
      "aria-expanded": "true",
      "aria-hidden": "false"
    }
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('download-excel', {
    attrs: {
      "data": _vm._.filter(_vm.json_data, function(p) {
        return _vm._.includes(_vm._.toLower(p.NomeEntidade + p.ds_nome + p.ds_fase + p.ds_numero_edital), _vm._.toLower(_vm.table.filter))
      }),
      "meta": _vm.json_meta,
      "type": "xls",
      "fields": _vm.json_fields,
      "name": "propostas.xls"
    }
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Exportar para Excel")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('form', {
    staticClass: "form-horizontal ng-pristine ng-valid ng-valid-mask ng-valid-maxlength ng-valid-date",
    attrs: {
      "name": "frmSearch",
      "id": "filtroProposta",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-md-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table.filter),
      expression: "table.filter"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa..."
    },
    domProps: {
      "value": (_vm.table.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.table, "filter", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "disabled": !_vm.table.filter,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.table.filter = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-right"
  }, [_c('g-button-ujarak', {
    attrs: {
      "onclick": "location.reload(true)",
      "color": "success",
      "size": "button--size-ss"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Atualizar Lista")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "ds_numero_edital",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value === '' ? 'Prospecção Direta' : row.value))]
      }
    }, {
      key: "NomeEntidade",
      fn: function(row) {
        return [(_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', {
          staticClass: "esmaecido"
        }, [_vm._v("[ "), _c('b', [_vm._v(_vm._s(row.item.id))]), _vm._v(" ]")]) : _vm._e(), _c('span', {
          staticClass: "esmaecido"
        }, [_vm._v(" " + _vm._s(_vm._f("cnpj")(row.item.ds_cnpj)))]), _vm._v(" " + _vm._s(row.value) + " ")]
      }
    }, {
      key: "dt_criado",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "ds_fase",
      fn: function(row) {
        return [(_vm.ehEdital(row.item)) ? _c('span', [(_vm._.includes(['CADASTRO', 'REVISAO', '', 'ANALISE'], row.value)) ? _c('span', [(!_vm.ehEditalAtivoNaoFinalizado(row.item)) ? _c('span', [_vm._v("Edital finalizado")]) : _vm._e(), _vm._v(" "), (_vm.ehEditalAtivoNaoFinalizado(row.item)) ? _c('span', [_vm._v("Edital em andamento")]) : _vm._e(), _vm._v(" "), (!_vm.ehEditalAtivoNaoFinalizado(row.item) && _vm._.includes(['ANALISE'], row.value) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', [_c('router-link', {
          attrs: {
            "to": {
              name: 'proposta-edita',
              params: {
                id: row.item.id,
                processo: row.item.ds_fase
              }
            }
          }
        }, [_vm._v(_vm._s(_vm.enumeradores[row.value]))])], 1) : _vm._e(), _vm._v(" "), (!_vm.ehEditalAtivoNaoFinalizado(row.item) && _vm._.includes(['REVISAO'], row.value) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', [_c('br'), _vm._v(" "), _c('router-link', {
          attrs: {
            "to": {
              name: 'proposta-edita',
              params: {
                id: row.item.id,
                processo: row.item.ds_fase
              }
            }
          }
        }, [_vm._v(_vm._s(_vm.enumeradores[row.value]))])], 1) : _vm._e()]) : _c('span', {
          class: _vm._.includes(['ANULACAO', 'ANULADO'], row.value) ? 'text-red' : (_vm._.includes(['APROVADO'], row.value) ? 'text-green' : '')
        }, [(_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.includes(['ANULACAO', 'ANULADO', 'APROVADO'], row.value) && !_vm.editalComLimitacaoAcesso()) ? _c('span', [_c('router-link', {
          attrs: {
            "to": {
              name: 'proposta-edita',
              params: {
                id: row.item.id,
                processo: row.item.ds_fase
              }
            }
          }
        }, [_vm._v(_vm._s(_vm.enumeradores[row.value]))])], 1) : _c('span', [_vm._v(_vm._s(_vm.enumeradores[row.value]))])])]) : _c('span', {
          class: _vm._.includes(['ANULACAO', 'ANULADO'], row.value) ? 'text-red' : (_vm._.includes(['APROVADO'], row.value) ? 'text-green' : '')
        }, [(_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.includes(['ANULACAO', 'ANULADO', 'APROVADO'], row.value)) ? _c('span', [_c('router-link', {
          attrs: {
            "to": {
              name: 'proposta-edita',
              params: {
                id: row.item.id,
                processo: row.item.ds_fase
              }
            }
          }
        }, [_vm._v(_vm._s(_vm.enumeradores[row.value]))])], 1) : _c('span', [_vm._v(_vm._s(_vm.enumeradores[row.value]))])])]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [(!_vm.ehEdital(row.item) || (_vm.ehEdital(row.item) && ((_vm.ehEditalAtivoNaoFinalizado(row.item) && _vm.usuarioLogado.userType !== 'FUNDACAO') || (!_vm.ehEditalAtivoNaoFinalizado(row.item) && _vm.usuarioLogado.userType === 'FUNDACAO')))) ? _c('span', [_c('g-button-ujarak', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large'
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
          }],
          attrs: {
            "color": "primary",
            "target": "_blank",
            "size": "button--size-ss",
            "disabled": false,
            "title": '<h5>Mostra uma versão para impressão do que já foi preenchida da proposta</h5>'
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'imprimir-proposta',
                params: {
                  id: row.item.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-text",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Versão para impressão\n                      ")]), _vm._v(" "), (_vm.ehEdital(row.item) && (_vm.ehEditalAtivoNaoFinalizado(row.item) && _vm.usuarioLogado.userType !== 'FUNDACAO') && row.item.ds_fase === 'ANALISE') ? _c('g-button-ujarak', {
          staticClass: "btn-primary",
          staticStyle: {
            "margin-top": "10px"
          },
          attrs: {
            "color": "error",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.alteraTarefaPropostaEdital(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Revisar Proposta\n                      ")]) : _vm._e(), _vm._v(" "), ((_vm.$root.authorize('proposta-cadastro-completo') || _vm.$root.authorize('minha-proposta-editar')) && (_vm._.includes(['CADASTRO', 'REVISAO', ''], row.item.ds_fase) || _vm._.isNull(row.item.ds_fase))) ? _c('div', [_c('div', [_c('g-button-ujarak', {
          staticClass: "btn-primary",
          staticStyle: {
            "margin-top": "10px"
          },
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'proposta-edita',
                params: {
                  id: row.item.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" " + _vm._s(row.item.ds_fase === 'CADASTRO' || _vm._.isNull(row.item.ds_fase) ? 'Editar' : (row.item.ds_fase === 'REVISAO' ? 'Revisar' : '')) + "\n                          ")]), _vm._v(" "), (row.item.ds_fase === 'ANALISE') ? _c('g-button-ujarak', {
          staticClass: "btn-primary",
          staticStyle: {
            "margin-top": "10px"
          },
          attrs: {
            "color": "error",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'proposta-edita',
                params: {
                  id: row.item.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Devolver para revisão\n                          ")]) : _vm._e()], 1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm.ehEdital(row.item) && ((!_vm.ehEditalAtivoNaoFinalizado(row.item) && _vm.usuarioLogado.userType !== 'FUNDACAO')))) ? _c('span', [_c('g-button-ujarak', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large'
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
          }],
          attrs: {
            "color": "primary",
            "target": "_blank",
            "size": "button--size-ss",
            "disabled": false,
            "title": '<h5>Mostra uma versão para impressão do que já foi preenchida da proposta</h5>'
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'imprimir-proposta',
                params: {
                  id: row.item.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-text",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Versão para impressão\n                      ")]), _vm._v(" "), (_vm.ehEdital(row.item) && (_vm.ehEditalAtivoNaoFinalizado(row.item) && _vm.usuarioLogado.userType !== 'FUNDACAO') && row.item.ds_fase === 'ANALISE') ? _c('g-button-ujarak', {
          staticClass: "btn-primary",
          staticStyle: {
            "margin-top": "10px"
          },
          attrs: {
            "color": "error",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.alteraTarefaPropostaEdital(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Revisar Proposta\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.ehEditalExcecao(row.item)) ? _c('g-button-ujarak', {
          staticClass: "btn-primary",
          staticStyle: {
            "margin-top": "10px"
          },
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'proposta-edita',
                params: {
                  id: row.item.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" " + _vm._s(row.item.ds_fase === 'CADASTRO' || _vm._.isNull(row.item.ds_fase) ? 'Editar' : (row.item.ds_fase === 'REVISAO' ? 'Revisar' : '')) + "\n                        ")]) : _vm._e(), _vm._v(" "), ((_vm.$root.authorize('proposta-cadastro-completo') || _vm.$root.authorize('minha-proposta-editar')) && (_vm._.includes(['CADASTRO', 'REVISAO', ''], row.item.ds_fase) || _vm._.isNull(row.item.ds_fase)) && _vm.ehEditalAtivoNaoFinalizado(row.item)) ? _c('div', [_c('div', [_c('g-button-ujarak', {
          staticClass: "btn-primary",
          staticStyle: {
            "margin-top": "10px"
          },
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'proposta-edita',
                params: {
                  id: row.item.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" " + _vm._s(row.item.ds_fase === 'CADASTRO' || _vm._.isNull(row.item.ds_fase) ? 'Editar' : (row.item.ds_fase === 'REVISAO' ? 'Revisar' : '')) + "\n                          ")]), _vm._v(" "), (row.item.ds_fase === 'ANALISE') ? _c('g-button-ujarak', {
          staticClass: "btn-primary",
          staticStyle: {
            "margin-top": "10px"
          },
          attrs: {
            "color": "error",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'proposta-edita',
                params: {
                  id: row.item.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Devolver para revisão\n                          ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), ((_vm.$root.authorize('proposta-cadastro-completo') || _vm.$root.authorize('minha-proposta-editar')) && (_vm._.includes(['REVISAO', ''], row.item.ds_fase) || _vm._.isNull(row.item.ds_fase))) ? _c('div', [_c('div', [_c('g-button-ujarak', {
          staticClass: "btn-primary",
          staticStyle: {
            "margin-top": "10px"
          },
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'proposta-edita',
                params: {
                  id: row.item.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" " + _vm._s(row.item.ds_fase === 'CADASTRO' || _vm._.isNull(row.item.ds_fase) ? 'Editar' : (row.item.ds_fase === 'REVISAO' ? 'Revisar' : '')) + "\n                          ")])], 1)]) : _vm._e()], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), (_vm.table.items.length > _vm.table.perPage) ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1)])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Lista de Propostas")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-96c3e7ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/proposta/ListaProposta.vue
// module id = 1976
// module chunks = 2